class ProductGallerySwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.breakpoint = 1024;
    this.lastIsMobile = null;

    this.handleResize = this.onResize.bind(this);
  }

  connectedCallback() {
    // DOM references moved here for safety
    this.container = this.querySelector('[data-swiper-el]');
    this.wrapper = this.querySelector('[data-swiper-wrapper]');
    this.slides = this.querySelectorAll('[data-swiper-slide]');
    this.prevEl = this.querySelector('[data-swiper-prev]');
    this.nextEl = this.querySelector('[data-swiper-next]');

    if (!this.container || !this.wrapper || !this.slides.length) {
      console.warn('ProductGallerySwiper: Required DOM elements missing.');
      return;
    }

    this.toggleSwiper(true); // force initial evaluation
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.destroySwiper();
  }

  toggleSwiper(force = false) {
    const isMobile = window.innerWidth < this.breakpoint;

    // Only run if the breakpoint context has changed or it's the first load
    if (force || isMobile !== this.lastIsMobile) {
      this.lastIsMobile = isMobile;

      if (isMobile && !this.swiperInstance) {
        this.addSwiperClasses();
        this.initSwiper();
      } else if (!isMobile && this.swiperInstance) {
        this.destroySwiper();
        this.removeSwiperClasses();
      }
    }
  }

  addSwiperClasses() {
    this.container.classList.add('swiper');
    this.wrapper.classList.add('swiper-wrapper');
    this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
  }

  removeSwiperClasses() {
    this.container.classList.remove('swiper');
    this.wrapper.classList.remove('swiper-wrapper');
    this.slides.forEach((slide) => slide.classList.remove('swiper-slide'));
  }

  initSwiper() {
    this.swiperInstance = new window.Swiper(this.container, {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1,
      loop: false,
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl,
      },
      grabCursor: true,
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  onResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.toggleSwiper(), 200);
  }
}

customElements.define('media-gallery', ProductGallerySwiper);
